import apiClient from '../apiClient';

/**
 * Frequent Orders API — fetches recent orders for a customer
 * placed by the current logged-in salesperson.
 * Used by the POS reorder feature.
 */

/**
 * Get the last N orders for a customer placed by the current user.
 * @param {string} customerPublicId - Customer public ID
 * @param {number} limit - Maximum number of orders to return (default 5)
 * @returns {Promise<Array>} List of order objects with items
 */
export const getFrequentOrders = async (customerPublicId, limit = 5) => {
    try {
        const response = await apiClient.get(
            `/orders/customer/${customerPublicId}/frequent`,
            { params: { limit } }
        );
        return response.data || [];
    } catch (error) {
        console.error('[FrequentOrderApi] Error fetching frequent orders:', error);
        throw error;
    }
};
